import React from "react";
import { Crown, Medal } from "lucide-react";

// Top-3 row styling shared by all leaderboards.
export const PODIUM = {
  1: {
    label: "GOLD",
    rowBg: "bg-yellow-400/[0.08] hover:bg-yellow-400/[0.12]",
    accentText: "text-yellow-300",
    ring: "shadow-[inset_3px_0_0_0_rgba(250,204,21,0.9)]",
    icon: <Crown size={14} className="text-yellow-300" />,
  },
  2: {
    label: "SILVER",
    rowBg: "bg-slate-300/[0.06] hover:bg-slate-300/[0.10]",
    accentText: "text-slate-200",
    ring: "shadow-[inset_3px_0_0_0_rgba(203,213,225,0.85)]",
    icon: <Medal size={14} className="text-slate-200" />,
  },
  3: {
    label: "BRONZE",
    rowBg: "bg-amber-600/[0.08] hover:bg-amber-600/[0.12]",
    accentText: "text-amber-400",
    ring: "shadow-[inset_3px_0_0_0_rgba(217,119,6,0.9)]",
    icon: <Medal size={14} className="text-amber-400" />,
  },
};
